import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { forwardRef } from 'react'

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** The glyph. Icons are aria-hidden, so `label` carries the meaning. */
  icon?: ReactNode
  /** Accessible name, and the tooltip. Required — an unlabelled icon is a guess. */
  label: string
  variant?: 'plain' | 'solid' | 'outline'
  size?: 'md' | 'lg'
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon, children, label, variant = 'plain', size = 'md', className, type = 'button', ...rest },
  ref,
) {
  const classes = [
    'rs-iconbtn',
    variant !== 'plain' ? `rs-iconbtn--${variant}` : '',
    size === 'lg' ? 'rs-iconbtn--lg' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button ref={ref} type={type} className={classes} aria-label={label} title={label} {...rest}>
      {icon ?? children}
    </button>
  )
})
